import React from "react";
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import { CreateForm } from "./components/CreateForm";

export const LocationCreate: React.FC = () => {
  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Instalaciones" : ""}
              defaultHref="/app/tic/instalaciones"
              color="light"
            />
          </IonButtons>
          <IonTitle>Nueva instalación</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">Nueva instalación</IonTitle>
          </IonToolbar>
        </IonHeader>
        <CreateForm />
      </IonContent>
    </IonPage>
  );
};
